'use client'

import * as React from "react"
import { cn } from "../../lib/utils"

const Switch = React.forwardRef(({ className, checked, onCheckedChange, ...props }, ref) => {
  const [internalChecked, setInternalChecked] = React.useState(false);

  const isControlled = checked !== undefined;
  const displayChecked = isControlled ? checked : internalChecked;

  const handleClick = () => {
    if (isControlled) {
      onCheckedChange(!checked);
    } else {
      setInternalChecked(!internalChecked);
      if (onCheckedChange) {
        onCheckedChange(!internalChecked);
      }
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={displayChecked}
      onClick={handleClick}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent p-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        displayChecked ? "bg-primary" : "bg-input",
        className
      )}
      {...props}
      ref={ref}
    >
      <span className="sr-only">Switch</span>
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-background shadow-lg ring-0 transition duration-200 ease-in-out",
          displayChecked ? "translate-x-5" : "translate-x-0"
        )}
      />
    </button>
  );
});
Switch.displayName = "Switch"

export { Switch }
